<ion-menu
  (ionWillClose)="closeFlyout()"
  class="facet-flyout"
  [ngClass]="
    platformType === platformEnum.mobile
      ? 'usf-mobile-flyout'
      : 'usf-desktop-flyout'
  "
>
  <ion-header class="ion-no-border facet-flyout-header">
    <ion-toolbar class="facet-flyout-toolbar">
      <ion-buttons slot="end">
        <ion-button (click)="closeFlyout()" class="flyout-close-button">
          <ion-icon name="close-outline"></ion-icon>
        </ion-button>
      </ion-buttons>
    </ion-toolbar>
    <ion-text>
      <h2 class="facet-flyout-title">{{ facetFlyoutTitle | translate }}</h2>
    </ion-text>
    <div class="facet-flyout-chips" *ngIf="isLoading === false">
      <ng-container
        *ngFor="
          let value of listFacet?.values | keyvalue;
          let i = index;
          trackBy: trackFacetValueId
        "
      >
        <ng-container
          *ngIf="value?.value?.isSelected"
          class="facet-regular-chip"
        >
          <app-usf-chip
            [clickable]="true"
            [type]="chipTypeEnum.selectedFilter"
            [iconConfig]="{
              rightIcon: true,
              color: '#56821f',
              iconUrl: 'assets/images/filter-selected-close.svg',
            }"
            (clickEmitter)="clearListFacet(value?.value)"
          >
            {{ value?.value?.value | titlecase }}
          </app-usf-chip>
        </ng-container>
      </ng-container>
      <ng-container *ngFor="let facetChip of facetChipViewModels; index as i">
        <ng-container
          *ngIf="facetChip.facet.type === 'regular'"
          class="facet-regular-chip"
        >
          <app-usf-chip
            [clickable]="true"
            [type]="chipTypeEnum.selectedFilter"
            [iconConfig]="{
              rightIcon: true,
              color: '#56821f',
              iconUrl: 'assets/images/filter-selected-close.svg',
            }"
            (clickEmitter)="facetChip.facet.toggleSelect(facetChip.facetValue)"
          >
            {{ facetChip.facetValue.value | titlecase }}
          </app-usf-chip>
        </ng-container>
        <ng-container *ngIf="facetChip.facet.type === 'hierarchical'">
          <ng-container
            *ngFor="let value of facetChip.facet.state.selectedValueAncestry"
          >
            <app-usf-chip
              [clickable]="true"
              [type]="chipTypeEnum.selectedFilter"
              [iconConfig]="{
                rightIcon: true,
                color: '#56821f',
                iconUrl: 'assets/images/filter-selected-close.svg',
              }"
              (clickEmitter)="facetChip.facet.deselectAll()"
              *ngIf="value.state === 'selected'"
            >
              {{ value.value | titlecase }}
            </app-usf-chip>
          </ng-container>
        </ng-container>
      </ng-container>
    </div>
  </ion-header>
  <ion-content class="facet-flyout-content">
    <div class="facet-flyout-loading-state" *ngIf="isLoading === true">
      <div class="facet-flyout-loading-text">
        {{ 'i18n.search.searchFlyout.updatingSelections' | translate }}
      </div>
      <ion-spinner name="circles"></ion-spinner>
    </div>
    <ion-accordion-group
      class="facet-flyout-accordion-group"
      *ngIf="isLoading === false"
      value="{{ currentFacetId }}"
    >
      <div *ngIf="facets.length === 0 && !!listFacet">
        <ng-container *ngTemplateOutlet="ListFacet"></ng-container>
      </div>
      <div *ngFor="let facet of facets; trackBy: trackFacetId; index as i">
        <div *ngIf="i === 1 && !!listFacet">
          <ng-container *ngTemplateOutlet="ListFacet"></ng-container>
        </div>
        <div *ngIf="!!facet && facet.type === 'regular'">
          <ion-accordion value="{{ facet.state.facetId }}">
            <ion-item slot="header" class="facet-header" lines="none">
              {{ facet.state.displayName }}
            </ion-item>
            <div slot="content" class="facet-value-list">
              <div class="facet-value-container">
                <ion-item
                  class="facet-selection-container"
                  *ngFor="
                    let value of facet.state.values;
                    let i = index;
                    last as isLast;
                    trackBy: trackFacetValueId
                  "
                  [class.first]="i === 0"
                  [class.last]="
                    isLast &&
                    (facet.state.canShowMoreValues ||
                      facet.state.canShowLessValues)
                  "
                >
                  <ion-checkbox
                    labelPlacement="start"
                    justify="space-between"
                    class="facet-selection"
                    mode="ios"
                    [checked]="value.state === 'selected'"
                    (ionChange)="handleCheckboxSelection(facet, value)"
                  >
                    <span class="facet-value-text">
                      {{
                        value.value
                          | acronymTitleCase
                          | truncateWithEllipsis: 40
                      }}
                    </span>
                    <ion-badge mode="ios">
                      {{ value.numberOfResults }}
                    </ion-badge>
                  </ion-checkbox>
                </ion-item>
                <ng-container
                  *ngTemplateOutlet="facetViewButton; context: { facet: facet }"
                ></ng-container>
              </div>
            </div>
          </ion-accordion>
        </div>

        <div *ngIf="!!facet && facet.type === 'hierarchical'">
          <ion-accordion
            value="{{ facet.state.facetId }}"
            *ngIf="
              facet.state.hasActiveValues === false ||
              facet.state.selectedValueAncestry[
                facet.state.selectedValueAncestry.length - 1
              ].children.length > 0
            "
          >
            <ion-item slot="header" class="facet-header" lines="none">
              {{ facet.state.displayName }}
            </ion-item>
            <div slot="content" class="facet-value-list">
              <div class="facet-value-container">
                <ng-container
                  *ngIf="facet?.state?.values[0]?.children?.length === 0"
                >
                  <ion-item
                    class="facet-selection-container"
                    *ngFor="let category of facet?.state?.values; let i = index"
                    [class.first]="i === 0"
                  >
                    <ion-checkbox
                      labelPlacement="start"
                      justify="space-between"
                      class="facet-selection"
                      mode="ios"
                      [checked]="category.state === 'selected'"
                      (ionChange)="handleCheckboxSelection(facet, category)"
                    >
                      <span class="facet-value-text">
                        {{
                          category.value
                            | acronymTitleCase
                            | truncateWithEllipsis: 40
                        }}
                      </span>
                      <ion-badge mode="ios">
                        {{ category.numberOfResults }}
                      </ion-badge>
                    </ion-checkbox>
                  </ion-item>
                </ng-container>
                <ng-container
                  *ngIf="
                    facet?.state?.selectedValueAncestry &&
                    facet?.state?.selectedValueAncestry.length > 0
                  "
                >
                  <ion-item
                    class="facet-selection-container"
                    *ngFor="
                      let category of facet?.state?.selectedValueAncestry[
                        facet?.state?.selectedValueAncestry.length - 1
                      ]?.children;
                      let i = index
                    "
                    [class.first]="i === 0"
                  >
                    <ion-checkbox
                      labelPlacement="start"
                      justify="space-between"
                      class="facet-selection"
                      mode="ios"
                      [checked]="category.state === 'selected'"
                      (ionChange)="handleCheckboxSelection(facet, category)"
                    >
                      <span class="facet-value-text">
                        {{
                          category.value
                            | acronymTitleCase
                            | truncateWithEllipsis: 40
                        }}
                      </span>
                      <ion-badge mode="ios">
                        {{ category.numberOfResults }}
                      </ion-badge>
                    </ion-checkbox>
                  </ion-item>
                </ng-container>
              </div>
            </div>
          </ion-accordion>
        </div>
      </div>
    </ion-accordion-group>
  </ion-content>
  <ion-footer class="facet-flyout-footer" mode="md" *ngIf="isLoading === false">
    <ion-button (click)="closeAndClearAll()" class="usf-outline-green-button">
      {{ 'i18n.common.clearAll' | translate }}
    </ion-button>
    <ion-button [ngClass]="'usf-fill-green-button'" (click)="closeFlyout()">{{
      'i18n.common.close' | translate
    }}</ion-button>
  </ion-footer>
</ion-menu>

<ng-template #facetViewButton let-facet="facet">
  <ion-button
    class="facet-view-button"
    *ngIf="facet.state?.canShowMoreValues"
    (click)="showMoreFacetValues(facet)"
    fill="clear"
  >
    <ion-text>
      {{ 'i18n.search.searchFlyout.viewMore' | translate }}
    </ion-text>
    <ion-icon
      name="chevron-down-outline"
      class="facet-value-icon"
      slot="end"
    ></ion-icon>
  </ion-button>

  <ion-button
    class="facet-view-button"
    *ngIf="facet.state?.canShowLessValues && !facet.state?.canShowMoreValues"
    (click)="showLessFacetValues(facet)"
    fill="clear"
  >
    <ion-text>
      {{ 'i18n.search.searchFlyout.viewLess' | translate }}
    </ion-text>
    <ion-icon name="chevron-up" class="facet-value-icon" slot="end"></ion-icon>
  </ion-button>
</ng-template>

<ng-template #ListFacet>
  <ion-accordion value="{{ listFacet?.displayName }}">
    <ion-item slot="header" class="facet-header" lines="none">
      {{ listFacet?.displayName }}
    </ion-item>
    <div slot="content" class="facet-value-list">
      <div class="facet-value-container">
        <ion-item
          class="facet-selection-container"
          *ngFor="
            let value of listFacet?.values | keyvalue;
            let i = index;
            trackBy: trackFacetValueId
          "
          [class.first]="i === 0"
        >
          <ion-checkbox
            labelPlacement="start"
            justify="space-between"
            class="facet-selection"
            mode="ios"
            [checked]="value?.value?.isSelected"
            (ionChange)="handleListFacetCheckboxSelection(value?.value)"
          >
            <span class="facet-value-text">
              {{
                value?.value?.value
                  | acronymTitleCase
                  | truncateWithEllipsis: 40
              }}
            </span>
          </ion-checkbox>
        </ion-item>
      </div>
    </div>
  </ion-accordion>
</ng-template>
